<div class="relative" [attr.data-field]="field?.fieldUuid"
     [attr.data-typeId]="field?.config?.typeId">
  <span *ngIf="field?.config?.label" [innerHTML]="field.config.label | safeHtml"></span>
  <span class="absolute right-0 mr-8 z-20 pointer-events-none text-xs text-grayDark" style="margin-top: 0.85rem;"
        *ngIf="field.config.append">{{ field.config.append }}</span>
</div>

